import React from 'react';
import { MonitoringFilter } from 'store/modules/monitoring_store/types';

interface MonitoringFilterTabsProps {
  value: MonitoringFilter;
  onChange: (filter: MonitoringFilter) => void;
}
const MonitoringFilterTabs = (props: MonitoringFilterTabsProps) => {
  const { value, onChange } = props;

  const filters: { label: string; value: MonitoringFilter }[] = [
    { label: 'Todos', value: 'all' },
    { label: 'Não lidos', value: 'unread' },
    { label: 'Importantes', value: 'important' },
    { label: 'Arquivados', value: 'archived' },
  ];

  return (
    <div className="d-flex mt-2 px-3">
      {filters.map((filter, index) => {
        const isActive = value === filter.value;

        return (
          <button
            key={filter.value}
            type="button"
            onClick={() => onChange(filter.value)}
            className={`btn btn-sm flex-fill ${index !== filters.length - 1 ? 'mr-1' : ''} ${
              isActive ? 'btn-primary' : 'btn-outline-primary'
            }`}
          >
            {filter.label}
          </button>
        );
      })}
    </div>
  );
};
export default MonitoringFilterTabs;
